import { Button, Center, Flex, Heading, useToast } from "@chakra-ui/react";
import { Form, FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { ICompany } from "../../../interfaces/ICompany";
import { useGetCompany, useUpdateCompany } from "../../../services/hooks/useCompanies";
import { ErrorPage } from "../../components/Error";
import { FieldInput } from "../../components/Form/FieldInput";
import { LoadingPage } from "../../components/Loading";

export function UpdateCompany() {
  const { id } = useParams();
  const toast = useToast();
  const { data, isError, isLoading } = useGetCompany(Number(id));
  const navigate = useNavigate();
  const goBack = () => navigate("/dashboard/companies");
  function onSuccess() {
    toast({
      title: "Companhia atualizada com sucesso",
      status: "success",
      position: "top-right",
    });
    goBack();
  }
  function onError() {
    toast({ title: "É preciso especificar um nome", status: "error", position: "top-right" });
  }

  if (isLoading) return <LoadingPage message="Buscando companhias" />;
  if (isError || data?.name === undefined) return <ErrorPage />;

  return <UpdateCompanyForm data={data} id={Number(id)} onSuccess={onSuccess} onError={onError} />;
}

interface UpdateCompanyFormProps {
  data: ICompany;
  id: number;
  onSuccess: () => void;
  onError: () => void;
}

export function UpdateCompanyForm({ data, id, onSuccess, onError }: UpdateCompanyFormProps) {
  const { mutate } = useUpdateCompany(id);
  const formik = useFormik({
    initialValues: {
      name: data?.name,
    },
    onSubmit: (values, helpers) => {
      helpers.resetForm();
      mutate(values, { onSuccess, onError });
    },
  });
  return (
    <Flex direction="column">
      <PageTitle title="Editar Companhia - Dashboard" />
      <Heading fontSize="21" textAlign="center" mb="6">
        EDITAR COMPANHIA
      </Heading>
      <FormikProvider value={formik}>
        <Form>
          <FieldInput label={"Nome"} name={"name"} type="text" />
        </Form>
        <Center mt="6" gap="2">
          <Button
            as={Link}
            type="button"
            variant="ghost"
            _hover={{ color: "black", bgColor: "white" }}
            to="/dashboard/companies"
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            colorScheme={"telegram"}
            bgColor={"telegram.700"}
            onClick={() => {
              formik.handleSubmit();
            }}
          >
            Alterar
          </Button>
        </Center>
      </FormikProvider>
    </Flex>
  );
}
